var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "whatsapp-chat-starter",
      class: { "fullscreen-mode": _vm.fullscreenMode },
    },
    [
      _c("h1", { staticClass: "gradient-title" }, [
        _vm._v(_vm._s(_vm.$t("message.wpStartSpeech"))),
      ]),
      _vm._v(" "),
      _vm.fullscreenMode
        ? _c("div", { staticClass: "icon-flow" }, [
            _c("div", { staticClass: "icon zoho" }, [_c("ZohoIcon")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c("div", { staticClass: "icon supsis" }, [_c("SupsisIcon")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "arrow" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon whatsapp" },
              [_c("WhatsappBusinessIcon")],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingZohoRecord
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "spinner" }),
          ])
        : _vm.zohoRecord
        ? _c("section", { staticClass: "contact-card" }, [
            _c("div", { staticClass: "contact-info" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("i", { staticClass: "fas fa-user" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.zohoRecord.Full_Name))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("i", { staticClass: "fas fa-user-tie" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("message.owner")) +
                      ": " +
                      _vm._s(_vm.zohoRecord.Owner.name)
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("i", { staticClass: "fas fa-phone" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.maskPhoneNumber(_vm.zohoRecord.Phone))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("i", { staticClass: "fas fa-envelope" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.maskEmail(_vm.zohoRecord.Email || ""))),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "no-record-info" }, [
            _vm._v(_vm._s(_vm.$t("message.noRecordFailed"))),
          ]),
      _vm._v(" "),
      !_vm.fullscreenMode
        ? _c(
            "div",
            [
              _c("label", { attrs: { for: "channelId" } }, [
                _vm._v(_vm._s(_vm.$t("message.channel"))),
              ]),
              _vm._v(" "),
              _c("small", [_vm._v(_vm._s(_vm.$t("message.channelDesc")))]),
              _vm._v(" "),
              _c("ChannelPicker", {
                attrs: {
                  "allowed-types": [
                    "whatsapp-qr",
                    "whatsapp-v2",
                    "whatsapp-business-api",
                  ],
                  autoSelectFirst: false,
                },
                model: {
                  value: _vm.channelId,
                  callback: function ($$v) {
                    _vm.channelId = $$v
                  },
                  expression: "channelId",
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "fullscreen-content" }, [
            _c("div", { staticClass: "channel-select-text" }, [
              _vm._v(_vm._s(_vm.$t("message.pleaseSelectStartChat"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "channel-boxes" },
              _vm._l(_vm.whatsappChannels, function (channel) {
                return _c(
                  "div",
                  {
                    key: channel._id,
                    staticClass: "channel-box",
                    class: {
                      selected: _vm.channelId === channel._id,
                      disabled: !_vm.isChannelAvailable(channel),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectChannel(channel)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "channel-icon", class: channel.type },
                      [
                        channel.type === "whatsapp-business-api"
                          ? _c("WhatsappBusinessIcon")
                          : channel.type === "whatsapp-v2"
                          ? _c("WhatsappV2")
                          : channel.type === "whatsapp-qr"
                          ? _c("WhatsappV1")
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "channel-name" }, [
                      _vm._v(_vm._s(channel.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "channel-number" }, [
                      _vm._v(_vm._s(channel.payload.phoneNumber)),
                    ]),
                    _vm._v(" "),
                    !_vm.isChannelAvailable(channel)
                      ? _c("div", { staticClass: "warning-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.notAuthorizedChannel"))
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
      _vm._v(" "),
      _c(
        "footer",
        [
          _c(
            "SupsisButton",
            { attrs: { danger: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("message.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", disabled: !_vm.zohoRecord },
              on: { click: _vm.startChat },
            },
            [_vm._v(_vm._s(_vm.$t("message.startChat")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isSending
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "spinner" }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }